define('gameday-index-gdads/subcomponents/AdvertisingUtils',['require','exports','module','gameday-index-url-hasher/UrlHasher','gameday-index-enums/enums/baseball/GIDDecoder'],function(require, exports, module) {
	var UrlHash = require("gameday-index-url-hasher/UrlHasher"),
		GID = require("gameday-index-enums/enums/baseball/GIDDecoder");

	var hashInfo = ""; // TODO: require in url hasher
	var crtg_nid = '3665',
		crtg_cookiename = 'crtg_mlb',
		crtg_varname = 'crtg_content',
		crtg_rnd = Math.floor(Math.random() * 99999999999),
		crtg_content;

	exports.getKeyVals = function() {
		var hash = UrlHash.getHashParams(),
			gidStr = hash.game,
			gid = new GID(gidStr);
		var game = gid.gid, // TODO: get gid from url hasher
			home = gid.home_team_code,
			away = gid.away_team_code,
			state = (hash.game_state !== "Pregame") ? "gameday" : "preview";

		var keyVals = "gid=" + game + ";team=" + home + ";team=" + away + ";pageid=" + state + ";";

		window.dc_keyVal = keyVals;
		return keyVals;
	};

	exports.enableCriteo = function(cookieOverride) {
		var enableCriteo = true; // getQueryParam('criteo') || true; TODO: get from URL hasher

		/**
		 * Criteo retargeting
		 * loads an async script that populates a global var from a cookie.
		 * this var is passed in the key/vals of ad calls
		 */
		function crtg_getCookie(c_name) {
			var i,
				x,
				y,
				ARRCookies = document.cookie.split(";");

			for (i = 0; i < ARRCookies.length; i++) {
				x = ARRCookies[i].substr(0, ARRCookies[i].indexOf("="));
				y = ARRCookies[i].substr(ARRCookies[i].indexOf("=") + 1);
				x = x.replace(/^\s+|\s+$/g, "");

				if (x == c_name) {
					return unescape(y);
				}
			}

			return '';
		}

		crtg_content = crtg_getCookie(cookieOverride || crtg_cookiename);

		if (enableCriteo) {
			(function() {
				var crtg_url = location.protocol + '//rtax.criteo.com/delivery/rta/rta.js?netId=' + escape(crtg_nid);
				crtg_url += '&cookieName=' + escape(cookieOverride || crtg_cookiename);
				crtg_url += '&rnd=' + crtg_rnd;
				crtg_url += '&varName=' + escape(crtg_varname);

				var crtg_script = document.createElement('script');
				crtg_script.type = 'text/javascript';
				crtg_script.src = crtg_url;
				crtg_script.async = true;

				if (document.getElementsByTagName("head").length > 0) {
					document.getElementsByTagName("head")[0].appendChild(crtg_script);
				} else if (document.getElementsByTagName("body").length > 0) {
					document.getElementsByTagName("body")[0].appendChild(crtg_script);
				}
			})();
		}
	};

	exports.getCrtgContent = function() {
		return crtg_content;
	};
});
